import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-avoir-fournisseur-tab-content',
  templateUrl: './avoir-fournisseur-tab-content.component.html',
  styleUrls: ['./avoir-fournisseur-tab-content.component.scss']
})
export class AvoirFournisseurTabContentComponent implements OnInit {
    status: string = 'Tous';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.status = this.route.snapshot.data['status'] || 'Tous';
    }
}
